import { render, staticRenderFns } from "./RfidView.vue?vue&type=template&id=af5e9ee2&"
import script from "./RfidView.vue?vue&type=script&lang=js&"
export * from "./RfidView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports